import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Login from './pages/Login';
import AppRouter from './components/AppRouter';
import { getRequest } from './apiService';
import './styling/menu.css';  
import './App.css'
import "./styling/dashboard.scss";
import "./styling/analytic.scss";
import "./styling/dashboard.scss";
import "./styling/calc.scss";
import "./styling/admin.scss";
import "./styling/marketing.scss"
import "./styling/prospects.scss";
import "./styling/sharedStyling/global.scss"
import "./styling/Overrides/override.scss"
import "./styling/ios.scss"

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    // Check if user is already logged in via session storage
    if (Number(sessionStorage.getItem("user-id")) > 0) {
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }

    // Check server session
    try {
      const result = await getRequest("user/session");
      if (result.success && result.data.data.id > 0) {
        handleLoginSuccess(result.data.data, false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Session check failed:', error);
      setIsLoading(false);
    }
  };

  const handleLoginSuccess = (userData, isFormLogin = true) => {
    // Store user data in session storage
    sessionStorage.setItem("user-id", Number(userData.id));
    sessionStorage.setItem("user-name", userData.name);
    sessionStorage.setItem("user-accessId", userData.access_id);
    sessionStorage.setItem("user-accessType", userData.accessGranted);
    sessionStorage.setItem("user-accessLevel", userData.accessLevel);
    sessionStorage.setItem("user-officeId", userData.officeId);
    sessionStorage.setItem("user-office", userData.office);
    sessionStorage.setItem("is_leader", userData.is_leader ? userData.is_leader : 0);
    sessionStorage.setItem("team_id", userData.team_id ? userData.team_id : 0);
    sessionStorage.setItem("team_name", userData.team_name ? userData.team_name : 0);
    sessionStorage.setItem("department_id", userData.department_id ? userData.department_id : 0);
    sessionStorage.setItem("department", userData.department ? userData.department : 0);

    setIsAuthenticated(true);
    setIsLoading(false);

    // Optional: Redirect based on user level
    // if (isFormLogin) {
    //   const redirectUrl = Number(userData.accessLevel) > 3 ? '/od-dashboard' : '/agent-dashboard';
    //   window.location.href = window.location.origin + redirectUrl;
    // }
  };

  if (isLoading) {
    return <div>Loading application...</div>;
  }

  return (
    <BrowserRouter>
      {isAuthenticated ? (
        <AppRouter />
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </BrowserRouter>
  );
}

export default App;